<ng-template [ngIf]="!centraliLoaded">
  <app-loading></app-loading>
</ng-template>

<div class="surface-card p-4 shadow-2 border-round">
  <div class="field mb-2">
    <label for="centrale" class="font-medium text-900">Richiedi che la pratica venga associata alla centrale:</label>
    <p-autoComplete class="ml-2 "
      [disabled]="!centraliLoaded"
      [(ngModel)]="centrale"
      [suggestions]="filteredCentrali" 
      (completeMethod)="filterCentrali($event)"
      field="clliAttestazione" 
      placeholder="CLLI CENTRALE"
      appendTo="body"
    ></p-autoComplete>
  </div>

  <div class="surface-border border-top-1 opacity-50 my-2"></div>

  <div class="flex justify-content-center gap-2">
    <p-button 
      icon="pi pi-check" 
      (onClick)="conferma(true)" 
      label="Conferma" 
      styleClass="p-button-success p-button-text" 
      [disabled]="!centrale"
    ></p-button>
    <p-button 
      icon="pi pi-times" 
      (onClick)="conferma(false)" 
      label="Annulla" 
      styleClass="p-button-warning p-button-text"
    ></p-button>
  </div>
</div>